import $ from "jquery";
import "select2";
import "select2/dist/js/i18n/cs";

$(".select2__control").select2({
  width: "100%",
  language: "cs",
});

$(".multi-select2__control").select2({
  width: "100%",
  language: "cs",
});